import { render } from "./LoginModal.3.vue?vue&type=template&id=d3c97f28&ts=true"
import script from "./LoginModal.3.vue?vue&type=script&lang=ts"
export * from "./LoginModal.3.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__